<template>
    <div class="select_wrap" v-if="isshow">
        <div class="select_box">
            <i class="el-icon-circle-close" @click="close"></i>
            <!--活动票种-->
            <div class="selectItem active_tick">
                <label>活动票种</label>
                <div class="tickWrap" data-mcs-theme="dark">
                    <div class="ticket_wrap">
                        <div class="ticket_list" v-bind:class="{activeList:selectTick===item,gray_list:item.status==9||item.status==20||eventinfo.status==9}" v-for="(item,index) in eventticketinfo" :key="index" @click="selectEvent(item)">
                            <div class="tickTop">
                                <span class="font16">{{item.tickettype==2?'￥'+item.uprice:item.tickettypename}} <b v-if="item.seasonticketcount!=1">{{item.seasonticketcount}}人套票</b></span>
                                <span class="status" v-if="item.statusname" v-bind:class="{y_status:item.status==9,g_status:item.status==20}">{{item.statusname}}</span>
                            </div>
                            <div class="tickBot">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tickDesp" v-if="selectTick.memo&&eventinfo.status==10">票种说明：{{selectTick.memo}}</div>
            <div class="tickDesp" v-if="eventinfo.status==9">当前活动报名时间暂未开始，请在 {{eventinfo.enrollbegintime}} - {{eventinfo.enrollendtime}}进行报名</div>
            <div class="selectItem">
                <label>购买数量</label>
                <div class="ticket_wrap">
                    <el-input-number v-model="num" @change="handleChange" :min="1"></el-input-number>
                </div>
            </div>
            <div class="selectItem">
                <div class="sign_button" v-if="eventinfo.status==10&&selectTick.status==1"><el-button type="primary" @click="goSign">立即报名</el-button></div>
                <div class="sign_button" v-else><el-button type="info"  :disabled="true">立即报名</el-button></div>
                <el-popover  placement="right"  width="200"  trigger="hover" :content="eventinfo.isrefund==1?'活动开始前支持退款':'该活动不支持退款'">
                    <el-button slot="reference" class=""><i class="el-icon-warning-outline"></i> 退款说明</el-button>
                </el-popover>
            </div>
        </div>
        <ComPoup ref="comPoup"></ComPoup>
    </div>
</template>

<script>
    import {getEventTicketInfo} from 'api/hdApi'
    import {mapActions} from 'vuex'
    import ComPoup from '@/views/hdPc/components/comPoup'
    import $ from 'jquery'
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css'
    export default {
        name: "selectTicket",
        props:['orderinfo'],
        data(){
            return{
                isshow:false,
                num:1,
                eventid:'', //活动id
                eventticketinfo:[], //票种信息
                eventinfo:{}, //活动信息
                // selectid:'', //选择的票种id
                selectTick:{
                    ticketid:'',
                    status:0
                }, //当前选择的票种
            }
        },
        mounted(){

        },
        methods:{
            //获取票种信息
            _getTickList(){
                this.setLoading(true);
                let param={
                    eventid:this.eventid
                };
                getEventTicketInfo({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.isshow=true;
                        this.eventinfo=data.data.eventinfo
                        this.eventticketinfo=data.data.eventticketinfo
                        this.eventticketinfo.forEach((item)=>{
                            if(this.selectTick.ticketid=='' && item.status==1 && this.eventinfo.status==10){
                                this.selectTick=item
                            }
                        });
                        $('.tickWrap').mCustomScrollbar({
                            autoHideScrollbar:true
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            open(id){
                this.eventid=id;
                this._getTickList()
            },
            close(){
                this.isshow=false;
                this.$emit('openDet')
                this.selectTick.ticketid='';
                this.selectTick.status=0
            },
            //选择票种
            selectEvent(val){
                if(val.status==1&&this.eventinfo.status==10){
                    this.selectTick=val;
                    this.num=1
                }
            },
            //立即报名
            goSign(){
                if(this.orderinfo.orderno){
                    this.$refs.comPoup.open();
                }else{
                    this.$router.push({name: 'SignForm',query:{eventid:this.eventid,ticketcount:this.num,ticketid:this.selectTick.ticketid}})
                }
            },
            handleChange(value) {
                if(value>this.selectTick.currentmaxbuycount){
                    let msg='最多购买'+this.selectTick.currentmaxbuycount+'张';
                    this.$message({
                        message: msg,
                        type: 'warning'
                    });
                    this.$nextTick(function () {
                        this.num=this.selectTick.currentmaxbuycount
                    });
                }
            },
            ...mapActions([
                'setLoading',
            ])
        },
        components:{
            ComPoup
        }
    }
</script>

<style lang="scss">
    .select_wrap{
        width: 732px;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        .select_box{
            padding: 20px;
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 8px 0px rgba(0,0,0,0.1);
            border-radius:6px;
            border:1px solid rgba(20,100,200,1);
            position: relative;
            min-height: 210px;
            z-index: 2;
            .el-icon-circle-close{
                position: absolute;
                right: 20px;
                top: 20px;
                font-size: 16px;
                color: #999;
                cursor: pointer;
            }
            .selectItem,.buyItem{
                label{
                    width: 80px;
                    min-width: 80px;
                    display: inline-block;
                }
                .ticket_wrap{
                    width: 510px;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .ticket_list{
                        width:220px;
                        height:auto;
                        min-height: 50px;
                        padding: 12px;
                        background:rgba(255,255,255,1);
                        border-radius:4px;
                        border:1px solid rgba(229,229,229,1);
                        margin-bottom: 12px;
                        cursor: pointer;
                        .tickTop{
                            font-size: 12px;
                            display: flex;
                            justify-content: space-between;
                            .font16{
                                font-size: 16px;
                                line-height: 22px;
                                display: inline-block;
                                b{
                                    color: #999;
                                    font-size: 14px;
                                    margin-left: 5px;
                                }
                            }
                            .status{
                                color: #FF6666;
                                background: #FFE7E7;
                                padding: 0 5px;
                                height: 20px;
                                line-height: 20px;
                                border-radius:2px;
                            }
                            .y_status{
                                background:rgba(255,199,91,1);
                                color: #fff;
                            }
                            .g_status{
                                background:rgba(229,229,229,1);
                                color: #999;
                            }
                        }
                        .tickBot{
                            margin-top: 10px;
                            font-size: 14px;
                            color: #999;
                        }
                    }
                    .activeList{
                        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
                        border-radius:4px;
                        border:1px solid rgba(20,100,200,1);
                        color: #1464C8;
                        .tickBot{
                            color: #1464C8;
                        }
                    }
                    .gray_list{
                        background:rgba(248,248,248,1);
                        border:1px solid rgba(229,229,229,1);
                        color: #999;
                    }
                }
            }
            .selectItem:last-child{
                margin-bottom: 0;
            }
            .selectItem{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                .el-button--default{
                    border: none;
                    color: #1464C8;
                    padding: 0 0;
                    margin-left: 20px;
                }
                .el-button:focus, .el-button:hover{
                    background: none;
                }
                .sign_button{
                    margin-left: 80px;
                    .el-button{
                        width: 140px;
                        border-radius:20px;
                        background: #1464C8;
                        border-color: #1464C8;
                    }
                    .el-button:focus, .el-button:hover{
                        opacity: 0.8;
                    }
                    .el-button--info.is-disabled{
                        background-color: #E5E5E5;
                        border-color: #E5E5E5;
                        color: #999;
                    }
                }
            }
            .active_tick{
                align-items: flex-start;
                margin-bottom: 0;
                .tickWrap{
                    height: auto;
                    max-height: 265px;
                    overflow-y: auto;
                }
            }
            .tickDesp{
                margin-left: 80px;
                margin-bottom: 20px;
                line-height: 25px;
                color: #FF6666;
            }
        }
    }
    /*滚动条样式*/
    .mCS-dark.mCSB_scrollTools .mCSB_draggerRail{
        background-color: #fff;
    }
    .mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{
        background-color: #ccc !important;
    }
</style>